import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy } from '@angular/core';
import { IWizItemRenderer, WizBaseCollector, WizEventManager, WizRoot } from '@wizeoo/akm-component-lib';

import { ALK_EVENT_TYPE } from '../../../model/enums';
import { AlkEvent } from '../../../framework/events/alk.event';

/**
 * rendu des champs disponibles
 */
@Component({
  selector: 'calendar-event-renderer',
  templateUrl: './calendar-event.renderer.html',
})
export class CalendarEventRenderer implements AfterViewInit, OnDestroy, IWizItemRenderer<null, any> {
  constructor( public elementRef: ElementRef, public cdref: ChangeDetectorRef ) {}
  data: any;
  owner: WizBaseCollector;

  ngAfterViewInit() {
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.UPDATE_CALENDAR_EVENT, this.refresh);
  }
  ngOnDestroy() {
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.UPDATE_CALENDAR_EVENT);
  }

  private refresh(e: AlkEvent): void {
    // console.log('refresh', e.data.extendedProps.id);
    if(this.data.extendedProps.id === e.data.extendedProps.id) {
      let exist: any = {...this.data.extendedProps};

      // console.log('refresh me', e.data.extendedProps.id);
      exist.title = e.data.title;
      exist.content = e.data.content;
      this.data.extendedProps = e.data.extendedProps;
      //this.data.title = 'maurice';
      // this.data.content = 'Béjart';
      this.cdref.markForCheck();
    }
  }

  public showDelete(): boolean {
    return !!this.data?.extendedProps?.context?.shd;
  }

  public get titleStr(): string {
    return this.data.extendedProps.title;
  }

  public get fullStr(): string {
    return this.data.extendedProps.title + ' - ' + this.data.extendedProps.content;
  }

  public get contentStr(): string {
    return this.data.extendedProps.content;
  }

  public get isSelected(): boolean {
    return this.data.extendedProps.ds.isSelected(this.data.extendedProps.widgetLine);
  }

  // public get contrast(): string {
  //   return this.data.extendedProps.contrast;
  // }

  public get color(): string {
    return this.data.extendedProps.color;
  }

  public doDelete(): void {
    WizEventManager.dispatchEvent(
      this.elementRef,
      new AlkEvent(ALK_EVENT_TYPE.DELETE_CALENDAR_EVENT, this.data.extendedProps)
    );
  }

  public doEdit(): void {
    WizEventManager.dispatchEvent(
      this.elementRef,
      new AlkEvent(ALK_EVENT_TYPE.EDIT_CALENDAR_EVENT, this.data.extendedProps)
    );
  }
}
